import React from 'react'
import styled from 'styled-components'
import media from 'styles/media'

type Props = {
  data: {
    formName: string
    sectionTitle: string
    submitText: string
    alternateRedirect: boolean | null
    alternateRedirectLink: string | null
    successPage?: {
      title: string
    }
    contentfulfields: [
      {
        fieldName: string
        required: boolean
        type: string
      }
    ]
  }
  inline?: boolean
}

const Form: React.FC<Props> = ({ data, inline }) => {
  const {
    formName,
    sectionTitle,
    submitText,
    contentfulfields,
    alternateRedirect,
    alternateRedirectLink,
    successPage,
  } = data

  const action = alternateRedirect
    ? alternateRedirectLink
      ? `/${alternateRedirectLink}`
      : '/'
    : successPage
    ? `/success-${successPage.title.split(' ').join('-').toLowerCase()}/`
    : '/thank-you/'

  return (
    <Wrapper inline={inline}>
      <Title>{sectionTitle}</Title>
      <FormLabel>{formName}</FormLabel>
      <StyledForm
        name={formName}
        method="POST"
        data-netlify="true"
        netlify-honeypot="Robot ID"
        action={action}
      >
        <input type="hidden" name="form-name" value={formName} />
        {contentfulfields.map((field, i) =>
          field.type.toLowerCase() === 'textarea' ? (
            <Text
              placeholder={field.fieldName}
              name={field.fieldName}
              key={i}
              required={field.required}
            />
          ) : (
            <Input
              placeholder={field.fieldName}
              name={field.fieldName}
              key={i}
              type={field.type.toLowerCase()}
              required={field.required}
            />
          )
        )}
        <Submit type="submit" value={submitText} />
      </StyledForm>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ inline?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 96px;
  margin-bottom: 60px;
  ${media.tablet} {
    padding: 109px ${(props) => (props.inline ? '0' : '72px')};
    display: block;
  }
  @media screen and (max-width: 800px) {
    padding: 47px 12px;
  }
`

const Title = styled.h2`
  font-family: 'Maison Neue';
  font-style: normal;
  font-weight: normal;
  font-size: 54px;
  line-height: 56px;
  width: 732px;
  margin-bottom: 40px;
  ${media.tablet} {
    width: 560px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`

const FormLabel = styled.span`
  font-family: 'Maison Neue';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  width: 732px;
  ${media.tablet} {
    width: 560px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`
const StyledForm = styled.form`
  width: 732px;
  padding: 96px 88px 56px;
  background: white;
  margin-top: 24px;
  ${media.tablet} {
    width: 672px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding: 48px 12px;
  }
`
const Input = styled.input`
  font-family: 'Maison Neue Mono';
  width: 100%;
  height: 48px;
  margin-bottom: 24px;
  border: 1px solid #141414;
  background: rgba(124, 161, 161, 0.12);
  padding: 14px 24px;
  font-size: 16px;
  line-height: 24px;
`

const Text = styled.textarea`
  font-family: 'Maison Neue Mono';
  width: 100%;
  height: 96px;
  margin-bottom: 24px;
  border: 1px solid #141414;
  background: rgba(124, 161, 161, 0.12);
  padding: 14px 24px;
  font-size: 16px;
  line-height: 24px;
`
const Submit = styled.input`
  height: 40px;
  border: 1px solid #141414;
  background: transparent;
  font-size: 16px;
  line-height: 16px;
  padding: 0 24px;
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`
export default Form
